<template>
  <p :class="['alert', { inline, simple }]">
    <em v-html="text"></em>
  </p>
</template>

<script lang="ts">
import { defineComponent } from '@vue/runtime-core'

export default defineComponent({
  name: 'Alert',

  props: {
    text: {
      type: String,
      required: true
    },
    inline: {
      type: Boolean,
      default: false
    },
    simple: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<style lang="scss" scoped>
.alert {
  margin-bottom: 40px;
  padding: 15px;
  border: 1px solid #f64545;
  color: #f64545;
  line-height: 1.78;

  > em {
    font-style: normal;
  }

  & + * {
    margin-top: 40px;
  }
}

.inline {
  margin-top: 7px;
  margin-bottom: 0;
  padding: 0;
  border: none;
  font-size: 1.2rem;
}

.simple {
  margin-bottom: 5px;
  padding: 0;
  border: none;
  text-align: center;
}
</style>
